var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__product__flag"},[_vm._v(" "+_vm._s(_vm.$t('EXCLUSIVE'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }